<template>
  <a-card :bordered='false'>
    <div class="m-b-20 s_flex_bian_c">
      <div>
        <span class='mr15'>
          <a-button type="primary" v-has:marketingActivityBoxAdd="()=> {$router.push('/marketing/marketingActivity/box/create?type=add&label_type=big')}">
            <PlusOutlined />
            创建活动
          </a-button>
        </span>
      </div>
    </div>
    <!--  -->
    <a-form ref='form' :model='search' :style="{'marginBottom':'20px'}" :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
      <a-form-item label="关键词" name='keyword'>
        <a-input v-model:value="search.keyword" style="width:270px" placeholder="活动ID、活动名称、备注" />
      </a-form-item>
      <a-form-item label="活动状态" name='status'>
        <a-select v-model:value="search.status" :style="{width:'180px'}">
          <a-select-option value="">全部</a-select-option>
          <a-select-option :value="1">未开始</a-select-option>
          <a-select-option :value="2">进行中</a-select-option>
          <a-select-option :value="3">已结束</a-select-option>
          <a-select-option :value="4">已禁用</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="码类型" name='label_type'>
        <a-select v-model:value="search.label_type" :style="{width:'180px'}">
          <a-select-option value="">全部</a-select-option>
          <a-select-option :value="2">中箱码</a-select-option>
          <a-select-option :value="1">箱码</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="活动物流码" name='code'>
          <a-input v-model:value="search.code" placeholder="请输入物流码" /> 
      </a-form-item>
      <a-form-item>
        <a-button type="primary" htmlType='submit' class='m-r-10'>搜索</a-button>
      </a-form-item>
    </a-form>
    <div>
      <a-table :pagination='false' rowKey="activity_id" :loading='listLoading' bordered :columns='columns' :data-source='data' :scroll="{ x: 'max-content'}" class="tableFixBox">
        <template #priority>
          <span>
            优先级
            <a-tooltip placement="right" :auto-adjust-overflow="false">
              <template #title>
                <p>优先级数值越大代表优先级越高；若优先级相同，时间越新，优先级越高</p>
              </template>
              <QuestionCircleOutlined />
            </a-tooltip>
          </span>
        </template>
        <template v-slot:priorityContent="{ record }">
          <a-popconfirm @confirm="confirmSetSort(record)" @cancel="initData" class='m-r-10'>
            <template #title>
              <a-input-number v-model:value="record.sort_level" placeholder="优先级" :precision="0" />
            </template>
            <template #icon>
              <span></span>
            </template>
            {{record.sort_level}}
            <FormOutlined />
          </a-popconfirm>
        </template>
        <template v-slot:ac_content="{ record }">
          <a-button class="ant-tag ant-tag-blue" v-has:marketingActivityBoxRange="()=>{rangeVisible=true;activity_id=record.activity_id}">活动范围</a-button>
          <a-button class="ant-tag ant-tag-blue" v-has:marketingActivityBoxPrize="()=>getAward(record)">活动奖项</a-button>
          <a-tag color="blue" :checked="false" v-has:marketingActivityBoxData="()=>{$router.push({path:'/marketing/marketingActivity/scan/activityData',query:{activity_id:record.activity_id,activity_type:record.activity_type}})}">活动数据</a-tag>
        </template>
        <template v-slot:schedule="{ record }">
          <!-- status="exception" -->
          <a-progress :percent="record.plan" status="active" />
        </template>
        <template v-slot:action="{ record }">
          <a-button size="small" type="primary" ghost href="javascript:;" v-has:marketingActivityBoxDetail="()=>{$router.push('/marketing/marketingActivity/box/detail?type=edit&label_type=big&activity_id='+record.activity_id+'&activity_type='+record.activity_type)}" class='m-r-10'>详情</a-button>
          <a-button type="primary" size="small" class='m-r-10' v-has:marketingActivityBoxEdit="()=>{$router.push('/marketing/marketingActivity/box/edit?type=edit&label_type=big&activity_id='+record.activity_id)}">编辑</a-button>
          <a-button type="danger" size="small" class='m-r-10' href="javascript:;" v-has:marketingActivityBoxStatus="()=>switchStatus(record)">{{record.is_open==1?'禁用':'启用'}}</a-button>
          <a-button type="danger" size="small" href="javascript:;" v-has:marketingActivityBoxDel="()=>del(record)">删除</a-button>
        </template>
      </a-table>
      <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `" />
    </div>
  </a-card>
  <a-modal v-model:visible="rangeVisible" title="活动范围" centered :width='1000' :footer="null" destroyOnClose>
    <range :activity_id="activity_id"  />
  </a-modal>
  <a-modal v-model:visible="awardVisible" title="活动奖项" centered :width='1000' :footer="null" destroyOnClose>
    <award :awardList="awardList" :detail="awardDetail" :template_type="template_type" />
  </a-modal>
</template> 
<script>
import { reactive, ref, toRefs, onMounted, inject } from "vue";
import {
  QuestionCircleOutlined,
  PlusOutlined,
  FormOutlined,
} from "@ant-design/icons-vue";
import range from "../../components/range/index";
import award from "../../components/award/index";
import { iscode } from "@/utils/app";
import {
  activitys,
  activitysSwitch,
  activitysDel,
  activitysTreeList,
} from "@/api/qrcodeActivitys";
import { message, Modal } from "ant-design-vue";
import { result } from "lodash";
const def = {
  page: 1,
  limit: 10,
  status: "",
  keyword: "",
  serial_sn: "",
  batch_sn: "",
  code:"",
  label_type:'',
  show_label_type:2
};
export default {
  name: "integralDetail",
  components: {
    QuestionCircleOutlined,
    PlusOutlined,
    FormOutlined,
    range,
    award,
  },
  setup() {
    const state = reactive({
      listLoading: false,
      total: 0,
      visible: false,
      rangeVisible: false,
      awardVisible: false,
      awardList: [],
      awardDetail: {},
      detailVisible: false,
      activity_id:"",
      template_type:""
    });
    let data = ref();

    let columns = [
      {
        title: "活动ID",
        dataIndex: "activity_id",
        key: "activity_id",
      },
      {
        title: "活动名称",
        dataIndex: "activity_name",
        key: "activity_name",
      },
      {
        title: "时间进度",
        key: "schedule",
        width: 180,
        slots: { customRender: "schedule" },
      },
      {
        title: "状态",
        dataIndex: "status_title",
        key: "status_title",
      },
      {
        title: "备注",
        dataIndex: "remarks",
        key: "remarks",
        width: 130,
      },
      {
        key: "priority",
        slots: { title: "priority", customRender: "priorityContent" },
      },
      {
        title: "码类型",
        dataIndex: "label_type_text",
        key: "label_type_text", 
      },
      {
        title: "活动内容",
        dataIndex: "ac_content",
        key: "ac_content",
        width: 330,
        slots: { customRender: "ac_content" },
      },
      {
        title: "操作",
        key: "action",
        width: 270,
        fixed:"right",
        slots: { customRender: "action" },
      },
    ];
    const initData = async (values) => {
      state.listLoading = true;
      data.value = [];
      let res = await activitys(values).then((res) => res.data);
      state.listLoading = false;
      if (iscode(res)) {
        data.value = res.data;
        state.total = res.meta.total;
      }
      state.listLoading = false;
    };
    const search = ref(def);
    // 页面筛选项搜索
    const pageSearchChange = () => {
      search.value.page=1
      initData(search.value);
    };
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
      initData(search.value);
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      search.value.page = 1;
      search.value.limit = limit;
      initData(search.value);
    };
    onMounted(() => {
      initData(search.value);
    });
    const $router = inject("$router");
    // 修改优先级
    const confirmSetSort = async (data) => {
      console.log(data);
      let result = await activitysSwitch(data.activity_id, {
        sort_level: data.sort_level,
      })
        .then((res) => res.data)
        .catch((error) => error);
      if (iscode(result, true)) {
        initData(search.value);
      }
    };
    
    const $Modal = inject("$Modal");
    // 删除
    const del = async (data) => {
      $Modal.confirm({
        centered: true,
        title: "温馨提示",
        content: '确定要删除该活动么？',
        onOk: async () => {
          let res = await activitysDel(data.activity_id).then((res) => res.data);
          if (iscode(res, true)) {
            initData(search.value);
          }
        }
      });
    };
    // 禁用启用
    const switchStatus = async (data) => {
      $Modal.confirm({
        centered: true,
        title: "温馨提示",
        content: `确定要${data.is_open==1?'禁用':'启用'}该活动么？`,
        onOk: async () => {
          let result = await activitysSwitch(data.activity_id, {
            is_open: 1 - Number(data.is_open),
          })
            .then((res) => res.data)
            .catch((error) => error);
          if (iscode(result, true)) {
            initData(search.value);
          }
        }
      });
      
    };
    
    // 活动奖项
    const getAward = async (data) => {
      let result = await activitysTreeList(data.activity_id)
        .then((res) => res.data)
        .catch((error) => error);
      if (iscode(result)) {
        state.awardVisible = true;
        state.awardDetail = result;
        state.awardList = result.data;
        state.template_type = data.template_type
      } else {
        message.error(result.message);
      }
    };
    const checkDetail = (data) => {
      state.activity_id = data.activity_id;
      state.detailVisible = true;
    };

    return {
      ...toRefs(state),
      search,
      data,
      columns,
      pageSearchChange,
      pageCurrentChange,
      pageSizeChange,
      initData,
      confirmSetSort,
      del,
      switchStatus,
      getAward,
      checkDetail,
    };
  },
};
</script>
<style lang="less" scoped>
.customerModal{
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 100;
  .mask{
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,.2);
  }
  .ModalContent{
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    background-color: #fff;
    width: 456px;
    height: 240px;
    display: flex;
    justify-content: center;
    align-items: center;
    div{
    width: 180px;
    height: 180px;
    background: #FFFFFF;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    &:nth-child(1){
      margin-right: 48px;
    }
      &:hover{
      box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
      }
    }
  }
}
</style>